import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { Supplier } from '../../models/supplier.model';
import { NgFor } from '@angular/common';

@Component({
    templateUrl: './orders-buyin-supplier-dialog.component.html',
    styleUrls: ['./orders-buyin-supplier-dialog.component.scss'],
    imports: [NgFor]
})
export class OrdersBuyinSupplierDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: Supplier, private dialogRef: MatDialogRef<OrdersBuyinSupplierDialogComponent>) {}

  public select(item: Supplier): void {
    this.dialogRef.close(item);
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}


